module.exports = __webpack_public_path__ + "img/aboutus_e.9c51dc1b.jpg";